<template>
    <div id="luck">
        <img src="http://static.yuread.cn/quick/luck1.png" alt="" class="top">
        <div class="lunpan">
            <div class="cishu">
                <span class="fl"></span>
                <span class="fr">每次消耗：200阅读币</span>

            </div>
            <div class="pan">
                <div class="box " :class="active == 1 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck8.png" alt="">
                    <h3>日卡</h3>
                    <p>全站免费看</p>
                </div>
                <div class="box" :class="active == 2 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck5.png" alt="">
                    <h3>1088阅读币</h3>
                    <p>超大金额</p>
                </div>
                <div class="box j" :class="active == 3 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck3.png" alt="">
                    <h3>3元优惠卷</h3>
                    <p>充值抵扣3元</p>
                </div>
                <div class="box" :class="active == 8 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck5.png" alt="">
                    <h3>608阅读币</h3>
                    <p>超大金额</p>
                </div>
                <div class="box btn" @click="doLuck">
                    开始抽奖
                </div>
                <div class="box" :class="active == 4 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck5.png" alt="">
                    <h3>208阅读币</h3>
                    <p>超大金额</p>
                </div>
                <div class="box j" :class="active == 7 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck4.png" alt="" >
                    <h3>5元优惠卷</h3>
                    <p>充值抵扣5元</p>
                </div>
                <div class="box" :class="active == 6 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck5.png" alt="">
                    <h3>808阅读币</h3>
                    <p>超大金额</p>
                </div>
                <div class="box" :class="active == 5 ? 'active' : ''">
                    <div class="bg"></div>
                    <img src="http://static.yuread.cn/quick/luck8.png" alt="">
                    <h3>月卡</h3>
                    <p>全站书免费看</p>
                </div>
            </div>
        </div>

        <div class="tab">
            <div class="tab-bar">
                <div @click="tab = 1">
                    <p>中奖名单</p>
                    <span v-show="tab == 1"></span>
                </div>
                <div @click="tab = 2">
                    <p>我的奖品</p>
                    <span v-show="tab == 2"></span>
                </div>
            </div>
            <div class="tab-content">
                <div v-show="tab == 1">
                    <ul>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                    </ul>
                </div>
                <div v-show="tab == 2">
                    <ul>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                        <li>恭喜167123123抽中 月卡</li>
                    </ul>
                </div>

            </div>
        </div>

        <div class="guize">
            <h1><span></span><span></span><span></span>活动规则<span></span><span></span><span></span></h1>
            <p>1、活动期间，用户可使用书币抽取奖品，单次抽奖消耗200书币；</p>
            <!--<p>2、每个用户每日最多可抽奖12次，抽奖次数使用完毕当天不可再抽；</p>-->
            <p>2、用户余额不足时，在本页面充值购买的抽奖次数，需在活动有效期内使用，逾期作废，不可兑换书币，不予返还；</p>
            <p>3、中奖结果在当前页面公布，点击上方“我的奖品”即可查看；</p>
            <p>4、奖品为书币和VIP时，中奖时自动加入账户，用户退出当前活动页面，点击“我的”即可查看账户余额和VIP到期时间；</p>
            <p>5、奖品为现金券时，充值时可以使用，请注意具体使用标准；奖品为图书时，中奖时自动为您加入书架，您可免费阅读该书；</p>
            <p>6、所有奖品均设有效期，请在有效期前使用，逾期不使用，不予补发；</p>
            <p>7、活动最终解释权在法律允许的范围内归活动举办方所有；</p>
        </div>

        <div class="recharge" v-show="dialog1">
            <div class="recharge1">
                <h3>优惠购买抽奖次数</h3>
                <span class="close iconfont icon-times" @click="dialog1 = false"></span>

                <div class="type ">
                    <div class="l" :class="type == 66 ? 'active' : ''" @click="type = 66;">
                        <span class="y">¥ 10</span>
                        <p class="b">8<span>次</span></p>
                    </div>
                    <div class="r">
                        <div class="rr" style="margin-bottom: 10px" :class="type == 67 ? 'active' : ''" @click="type = 67;">

                            <p class="b"><span class="y">¥5</span> 3<span>次</span></p>
                        </div>
                        <div class="rr" :class="type == 68 ? 'active' : ''" @click="type = 68;">

                            <p class="b"><span class="y">¥2</span> 1<span>次</span></p>
                        </div>
                    </div>
                </div>

                <p class="tip">提示：所有抽奖次数限活动有效期内使用，过期作废，不可兑换书币。</p>
                <button>微信充值</button>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Luck",
        data(){
            return {
                userInfo : {},
                dialog1 : 0,
                type : 66,

                active: 0,
                tab : 1,
                loading : false,
                a : {}
            }
        },
        methods:{
            doLuck(){

                if(this.userInfo.money < 200){
                    this.dialog1 = true;
                    return;
                }

                if(this.loading){
                    return ;
                }
                this.loading = true;
                this.active = 1;
                this.a = setInterval(res => {
                    this.active ++;
                    if(this.active == 9){
                        this.active = 1;
                    }
                },50)
            },
            getUserInfo(){
                this.axios.post('/api/user/getUserInfo').then(r => {
                    let data = r.data;
                    if(data.code == 1){
                        this.$store.dispatch('setUserInfo',data.data);
                        this.userInfo = data.data;
                    }
                })
            }
        },
        created(){
            this.userInfo = this.$store.getters.getUserInfo;
            if(!this.userInfo.id){
                this.$router.push({name:"Login",query:{cburl:this.$route.path}});
                return ;
            }

            this.getUserInfo();


        }
    }
</script>

<style lang="less">
#luck{background: #F58E00;height: 100%;overflow: auto;
    .recharge{position: fixed;top:0;bottom:0;width: 100%;background: rgba(0,0,0,.4);z-index: 999;
        .recharge1{position: absolute;left:0;right:0;background: #fff;margin:400px auto;width: 524px;height:620px;border-radius: 28px;
            h3{font-size: 32px;color: #ff9718;text-align:center;border-bottom: 1px solid #e8e8e8;line-height: 100px;}
            .close{position: absolute;top:30px;right:30px;font-size: 18px;color: #CBCBCB;}

            .type{width: 410px;margin:56px auto 0;overflow: auto;padding-bottom: 10px;
                .l{width: 164px;height:224px;border-radius: 14px;border:6px solid transparent;box-shadow: 0px 4px 8px 0px rgba(255, 151, 24, 0.28);float: left;
                    .y{display: block;width: 114px;height: 44px;border-radius: 22px;background: #fed500;margin:32px auto 20px;text-align: center;font-size: 32px;color: #fff;}
                    p{text-align: center;font-size: 84px;font-weight: bold;color: #3c3755;
                        span{font-size: 28px;}
                    }
                }

                .r{float: right;width: 222px;height: 224px;
                    .rr{height:102px;border-radius: 14px;border:6px solid transparent;box-shadow: 0px 4px 8px 0px rgba(255, 151, 24, 0.28);
                        .b{text-align: center;font-size: 60px;color: #3C3755;
                            span{font-size: 28px;}
                            .y{display:inline-block;width:82px;height:44px;border-radius: 22px;color: #fff;font-size: 32px;background: #FED500;}
                        }
                    }
                }
                .active{border-color: #FF9718 !important;}
            }
            .tip{padding:20px 50px;color: #828282;font-size: 22px;}
            button{margin:20px auto 0;display:block;border:0;height: 68px;width: 200px;border-radius: 34px;background: #32BE1B;color: #fff;font-size: 32px;}
        }
    }


    .top{height: 666px;width: 100%;}
    .lunpan{width: 690px;border-radius: 16px;margin:0 auto;padding:22px;background: linear-gradient(180deg, #FFE9A7 0%, #FCD878 50%, #FDE5A5 100%);
        .cishu{overflow: auto;font-size:24px;color: #f14100;}
        .pan{width: 645px;height: 645px;background-image: url("http://static.yuread.cn/quick/luck2.png");background-size: 100% 100%;margin: 20px 0;display: flex;flex-wrap: wrap;justify-content: space-between;padding: 50px;
            .box{width: 174px;height:174px;background: #FFF2DF;text-align: center;border-radius: 18px;position: relative;overflow: hidden;padding-top: 20px;
                .bg{position: absolute;top:0;right:0;background: #fff;border-radius: 2px;width: 165px;height: 160px;z-index: 1}
                img{height: 76px;position: relative;z-index: 9;}
                h3{font-size:24px;color: #FF9400;position: relative;top:-20px;z-index: 9;}
                p{font-size: 16px;color: #F79029;position: relative;top:-20px;z-index: 9;margin: 0;padding: 0;}

            }
            .j{
                img{height: 60px;margin-bottom:16px;}
            }
            .btn{background: linear-gradient(270deg, #FFB837 0%, #FF7D00 100%);color: #fff;font-size: 48px;font-weight: bold;padding: 25px;}
            .active{background: #FF5D22;
                .bg{background: #F14100;}
                h3,p{color: #fff;}

            }
        }
    }

    .tab{width: 690px;border-radius: 16px;margin:20px auto;background: linear-gradient(180deg, #FFE9A7 0%, #FCD878 50%, #FDE5A5 100%);padding:34px;
        .tab-bar{display: flex;
            div{width: 50%;text-align: center;
                p{color: #F14100;font-size: 32px;}
                span{display: inline-block;width: 80px;height: 4px;background: #F14100;position: relative;top:-10px;border-radius: 2px;}
            }
        }
        .tab-content{
            div{height: 500px;
                ul{height: 100%;overflow: auto;
                    li{line-height: 60px;border-bottom: 2px #e6cd8d dashed;font-size: 24px;color: #F14100;}

                }
            }
        }
    }

    .guize{width: 690px;border-radius: 16px;margin:0 auto 100px;padding:40px;background: linear-gradient(180deg, #FFE9A7 0%, #FCD878 50%, #FDE5A5 100%);
        h1{text-align: center;font-size: 44px;color: #F14100;
            span{width: 6px;height: 18px;background: #F14100;display: inline-block;margin: 0 6px;position:relative;top:-6px;}
        }
        p{font-size: 24px;color: #f14100;line-height: 34px;margin-bottom: 20px;}
    }
}
</style>
